var map = {
	"./1/symbol_0.png": 32784,
	"./1/symbol_1.png": 48537,
	"./1/symbol_10.png": 19773,
	"./1/symbol_11.png": 98644,
	"./1/symbol_12.png": 17551,
	"./1/symbol_2.png": 34530,
	"./1/symbol_3.png": 98187,
	"./1/symbol_4.png": 6196,
	"./1/symbol_5.png": 27325,
	"./1/symbol_6.png": 59910,
	"./1/symbol_7.png": 28655,
	"./1/symbol_8.png": 27000,
	"./1/symbol_9.png": 99713,
	"./2/symbol_0.png": 17869,
	"./2/symbol_1.png": 75364,
	"./2/symbol_10.png": 38814,
	"./2/symbol_11.png": 91303,
	"./2/symbol_12.png": 72300,
	"./2/symbol_2.png": 5279,
	"./2/symbol_3.png": 27190,
	"./2/symbol_4.png": 1449,
	"./2/symbol_5.png": 30272,
	"./2/symbol_6.png": 85307,
	"./2/symbol_7.png": 36306,
	"./2/symbol_8.png": 88309,
	"./2/symbol_9.png": 5420,
	"./3/symbol_0.png": 32778,
	"./3/symbol_1.png": 83539,
	"./3/symbol_10.png": 20616,
	"./3/symbol_12.png": 91081,
	"./3/symbol_2.png": 9048,
	"./3/symbol_3.png": 81761,
	"./3/symbol_4.png": 98670,
	"./3/symbol_5.png": 88663,
	"./3/symbol_6.png": 99932,
	"./3/symbol_7.png": 17445,
	"./3/symbol_8.png": 16578,
	"./3/symbol_9.png": 80235,
	"./4/symbol_0.png": 21068,
	"./4/symbol_1.png": 85398,
	"./4/symbol_10.png": 38020,
	"./4/symbol_12.png": 96342,
	"./4/symbol_2.png": 99373,
	"./4/symbol_3.png": 45476,
	"./4/symbol_4.png": 25691,
	"./4/symbol_5.png": 94514,
	"./4/symbol_6.png": 25481,
	"./4/symbol_7.png": 47360,
	"./4/symbol_8.png": 48455,
	"./4/symbol_9.png": 79614,
	"./gold1.png": 8726,
	"./gold2.png": 99405,
	"./gold3.png": 73252,
	"./gold4.png": 66843,
	"./lose.png": 3702,
	"./silver1.png": 54377,
	"./silver2.png": 6194,
	"./silver3.png": 27739,
	"./silver4.png": 72932,
	"./slotmachine.png": 30162,
	"./win.png": 63123
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44138;